import React from 'react';
import styled from 'styled-components';

import { Image } from '@lt/components';

import { absoluteDivStyles } from '../styles';

interface ICountryBackgroundImage {
  src: string;
}

export const CountryBackgroundImage = (props: ICountryBackgroundImage) => {
  const { src } = props;

  return (
    <>
      <StyledBackgroundImage
        src={src}
        fallback={src}
        type="image/jpeg"
        loading="lazy"
      />
      <StyledImageOverlay />
    </>
  );
};

export const StyledBackgroundImage = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 4px;

  object-fit: cover;
  object-position: center;
`;

export const StyledImageOverlay = styled.div`
  ${absoluteDivStyles}

  background: linear-gradient(
    0deg,
    rgba(23, 24, 26, 0.3),
    rgba(23, 24, 26, 0.3)
  );
`;
